import { useField } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { InsightsBox } from '@@/InsightsBox';
import { FormSection } from '@@/form-components/FormSection/FormSection';

const fieldKey = 'Observability';

// ensure to add a disclaimer with the info of not scale tested and only for non-production environments to the tooltip
export function EnableObservabilitySection() {
  const [inputProps, meta, helpers] = useField<boolean>(fieldKey);

  return (
    <FormSection title="Observability">
      <InsightsBox
        header="Disclaimer"
        type="slim"
        content={
          <div className="space-y-3">
            <div>
              While this feature is called Observability, it currently only
              supports alerting; additional observability capabilities will be
              introduced in future updates.
            </div>
          </div>
        }
        className="mb-3"
      />
      <FormControl
        inputId="experimental_observability"
        label="Observability"
        size="medium"
        errors={meta.error}
      >
        <Switch
          id="additional_functionality_observability"
          data-cy="enable-observability-switch"
          name={fieldKey}
          className="space-right"
          checked={inputProps.value}
          onChange={handleChange}
        />
      </FormControl>
      <div className="text-muted small">
        Enable Observability for Portainer Alert Manager to proactively monitor
        environments for downtime or critical resource consumption thresholds,
        then receive notifications via Slack, Microsoft Teams, email, or
        webhook.
      </div>
    </FormSection>
  );

  function handleChange(enable: boolean) {
    helpers.setValue(enable);
  }
}
